module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/.store/core-js@2.6.12/~/core-js/library/modules/_add-to-unscopables.js
// module id = 665
// module chunks = 75